// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"F0-z","displaySixCardTiles":"G0-z"};